import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const PluginOrganizationOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginOrganizationOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idOrganizationOwner"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PluginOrganizationOwner","document":PluginOrganizationOwnerDocument}} as const;
export type PluginOrganizationOwnerQueryVariables = Types.Exact<{
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type PluginOrganizationOwnerQuery = (
  { __typename: 'Query' }
  & { plugin?: Types.Maybe<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id' | 'idOrganizationOwner'>
  )> }
);

/**
 * __usePluginOrganizationOwnerQuery__
 *
 * To run a query within a React component, call `usePluginOrganizationOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginOrganizationOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginOrganizationOwnerQuery({
 *   variables: {
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function usePluginOrganizationOwnerQuery(
  baseOptions: TrelloQueryHookOptions<
    PluginOrganizationOwnerQuery,
    PluginOrganizationOwnerQueryVariables
  > &
    (
      | { variables: PluginOrganizationOwnerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: PluginOrganizationOwnerDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    PluginOrganizationOwnerQuery,
    PluginOrganizationOwnerQueryVariables
  >(PluginOrganizationOwnerDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function usePluginOrganizationOwnerLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    PluginOrganizationOwnerQuery,
    PluginOrganizationOwnerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PluginOrganizationOwnerQuery,
    PluginOrganizationOwnerQueryVariables
  >(PluginOrganizationOwnerDocument, options);
}
export function usePluginOrganizationOwnerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        PluginOrganizationOwnerQuery,
        PluginOrganizationOwnerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PluginOrganizationOwnerQuery,
    PluginOrganizationOwnerQueryVariables
  >(PluginOrganizationOwnerDocument, options);
}
export type PluginOrganizationOwnerQueryHookResult = ReturnType<
  typeof usePluginOrganizationOwnerQuery
>;
export type PluginOrganizationOwnerLazyQueryHookResult = ReturnType<
  typeof usePluginOrganizationOwnerLazyQuery
>;
export type PluginOrganizationOwnerSuspenseQueryHookResult = ReturnType<
  typeof usePluginOrganizationOwnerSuspenseQuery
>;
export type PluginOrganizationOwnerQueryResult = Apollo.QueryResult<
  PluginOrganizationOwnerQuery,
  PluginOrganizationOwnerQueryVariables
>;
